<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>提交日报</span>
      </div>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <h3>时间</h3>
        <el-form-item label="日报时间:" prop="reportTime" class="w300">
          <el-date-picker v-model="form.reportTime" type="date" size="small" :picker-options="pickerDisabled"
                          value-format="yyyy-MM-dd" placeholder="选择日期" :disabled="disabledTime"
                          @change="pickerDate"></el-date-picker>
        </el-form-item>
        <!-- <el-date-picker v-model="value1" :default-value="value2" type="week"   placeholder="选择周"  @change="selData"></el-date-picker> -->
        <div style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          ">
          <h3>需求</h3>
          <el-button @click="batchSet" size="small" type="primary">批量设置</el-button>
        </div>
        <reportTable ref="demandTable" :showSummary="true" :tableNameList="demand.tableColumns" :tableData="demandData"
                     :controller="demandTableController" @handleSelectionChange="selectionChange">
          <template slot="type" slot-scope="list">
            <select-tmpl v-model="list.scope.row.type" :dataOption="demandOptions.Demand_Role" labels="name" values="id"
                         placeholder="请选择" size="small"
                         @select="changeOption(list, list.scope.$index)"></select-tmpl>
          </template>
          <template slot="projectName" slot-scope="list">
            <span>{{
                _getLabel(list.scope.row, projectOptions, "projectName")
              }}</span>
          </template>

          <template slot="costTime" slot-scope="list">
            <div class="canClick" @dblclick="$set(list.scope.row, 'costTimeFlag', true)"
                 v-show="!list.scope.row.costTimeFlag">
              <div v-if="!list.scope.row.costTime" class="Disabled">
                双击填写
              </div>
              <span v-else>{{ list.scope.row.costTime }}h</span>
            </div>
            <el-input size="small" v-model="list.scope.row.costTime" v-show="list.scope.row.costTimeFlag"
                      @blur="$delete(list.scope.row, 'costTimeFlag')"></el-input>
          </template>

          <template slot="control" slot-scope="list">
            <el-button @click="delDemand(list.scope.$index)" type="text" size="small">删除</el-button>
          </template>
        </reportTable>
        <br/>
        <el-button size="small" type="primary" @click="addDemand" icon="el-icon-plus">新增一项</el-button>
        <el-divider></el-divider>
        <h3>任务</h3>
        <reportTable
          :showSummary="true"
          :tableNameList="task.tableColumns"
          :tableData="taskData"
          :controller="tableController"
          @handleSelectionChange="handleSelectionChange"
        >
          <template slot="type" slot-scope="list">
            <el-popover placement="top-start" width="200" trigger="hover">
              <select-tmpl v-model="list.scope.row.type" :dataOption="taskOptions.TASK_TYPE" labels="name" values="id"
                           placeholder="请选择" size="small" :clearable="false"></select-tmpl>
              <span slot="reference">{{ _getLabel(list.scope.row, taskOptions.TASK_TYPE, "type") }}</span>
            </el-popover>
          </template>
          <template slot="projectName" slot-scope="list">
            <span>{{
                _getLabel(list.scope.row, projectOptions, "projectId")
              }}</span>
          </template>
          <template slot="content" slot-scope="list">
            <el-popover placement="top-start" width="200" trigger="hover">
              <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 8 }" class="elInput"
                        v-model="list.scope.row['content']"></el-input>
              <div slot="reference" v-html="list.scope.row['content']" class="table-content">
                {{ list.scope.row["content"] }}
              </div>
            </el-popover>
          </template>
          <template slot="costTime" slot-scope="list">
            <div class="canClick" @dblclick="$set(list.scope.row, 'costTimeFlag', true)"
                 v-show="!list.scope.row.costTimeFlag">
              {{ list.scope.row.costTime }}h
              <div v-if="!list.scope.row.costTime" class="Disabled"></div>
            </div>
            <el-input size="small" v-model="list.scope.row.costTime" v-show="list.scope.row.costTimeFlag"
                      @blur="$delete(list.scope.row, 'costTimeFlag')"></el-input>
          </template>
          <template slot="control" slot-scope="list">
            <el-button @click="editTask(list.scope.$index)" type="text" size="small">编辑</el-button>
            <el-button @click="delTask(list.scope.$index)" type="text" size="small">删除</el-button>
          </template>
        </reportTable>
        <br/>
        <el-button size="small" type="primary" @click="addTask" icon="el-icon-plus">新增一项</el-button>
        <el-divider></el-divider>
        <h3>加班</h3>
        <reportTable
          :tableNameList="meeting.tableColumns"
          :tableData="overTimeVOList"
          :controller="meetingController"
          @handleSelectionChange="handleSelectionChange"
        >
          <!-- <template slot="projectVO" slot-scope="list">
            <span>{{ getVersionName(list.scope.row) }}</span>
          </template>
          <template slot="endTime" slot-scope="list">
            <span>{{
              getTime(list.scope.row.startTime, list.scope.row.endTime)
            }}</span>
          </template> -->
        </reportTable>
        <br/>
        <el-divider></el-divider>
        <h3>请假</h3>
        <div class="ot-mian" style="margin-top: 10px;">
          <div class="ot">
            <select-tmpl v-model="dailyLeaveDTO.leaveType" :dataOption="otOptions.Demand_Role" labels="name" values="id"
                         placeholder="请选择请假类型" size="small"></select-tmpl>
          </div>
          <div class="ot ot2">
            <el-input-number size="small" v-model="dailyLeaveDTO.leaveTotalTime" :precision="1" :min="0" :step="0.1"
                             :max="8"></el-input-number>&nbsp; 小时
            <el-button
              type="danger"
              :disabled="!(dailyLeaveDTO.leaveType || dailyLeaveDTO.leaveTotalTime)"
              size="mini"
              @click="dailyLeaveDTO.leaveType=undefined;dailyLeaveDTO.leaveTotalTime=0"
            >
              删除
            </el-button>
          </div>
          <!-- <span class="red">需求总耗时(最小单位为0.5小时)</span> -->
        </div>
        <el-divider></el-divider>
        <h3>日常反馈</h3>
        <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 8 }" placeholder="请输入内容"
                  v-model="form.feedback"></el-input>
        <br/>
        <div class="txtContent">
          <el-button :loading="btnLoading" v-if="this.$route.query.dailyId || dailyId" size="small" type="primary"
                     @click="add(0)">重新提交
          </el-button>
          <el-button :loading="btnLoading" v-else size="small" type="primary" @click="add(-1)"
                     v-preventReClick>提交
          </el-button>
          <el-button size="small" @click="$router.go(-1)">返回</el-button>
        </div>
      </el-form>
    </el-card>
    <!-- 任务弹窗 -->
    <dialog-panel
      :title="taskTitle"
      :dialogController="addTaskBord"
      :width="'30%'"
      @cancel="closeTaskDialog"
      :showCancel="false"
      :showConfirm="false"
      :closeOnClickModal="false"
    >
      <el-form ref="taskForm" :model="taskForm" :rules="taskRules">
        <el-input v-model="taskForm.genre" type="hidden"></el-input>
        <el-form-item label="任务类别" prop="type" class="marginLeft">
          <select-tmpl v-model="taskForm.type" :dataOption="taskOptions.TASK_TYPE" labels="name" values="id"
                       placeholder="请选择" size="small"/>
        </el-form-item>
        <el-form-item label="选择项目:" prop="projectId">
          <select-tmpl v-model="taskForm.projectId" :dataOption="projectOptions" labels="name" values="id"
                       placeholder="请选择项目" @select="getSelect" size="small"/>
        </el-form-item>
        <el-form-item label="选择版本:" prop="projectVersionId">
          <select-tmpl v-model="taskForm.projectVersionId" :dataOption="versionOptions" labels="version" values="id"
                       placeholder="请选择版本" size="small"/>
        </el-form-item>
        <el-form-item label="任务说明" class="marginLeft">
          <el-input type="textarea" class="txtOverflow" :autosize="{ minRows: 5, maxRows: 8 }" placeholder="请输入内容"
                    v-model="taskForm.content"/>
        </el-form-item>
        <el-form-item label="耗时：" class="marginLeft">
          <!-- <el-input
            :autosize="{ minRows: 5, maxRows: 8}"
            placeholder="最小耗时为0.5小时"
            v-model="taskForm.costTime"
            size="small"
          ></el-input>-->
          <el-input-number size="small" v-model="taskForm.costTime" :precision="1" :step="0.5" :max="168"
                           :min="0.5"></el-input-number>&nbsp; 小时
          <br/>
          <span class="red">最小耗时为0.5小时</span>
        </el-form-item>
      </el-form>
      <div class="dialogBottom">
        <el-button
          v-show="isAdd"
          :loading="btnLoading"
          type="primary"
          size="small"
          @click="addTaskItem"
          v-preventReClick
        >
          添加
        </el-button>
        <el-button
          v-show="!isAdd"
          :loading="btnLoading"
          type="primary"
          size="small"
          @click="updateTaskItem"
          v-preventReClick
        >
          修改
        </el-button>
      </div>
    </dialog-panel>

    <!-- 需求 -->
    <dialog-panel
      :title="demandTitle"
      :dialogController="addDemandBord"
      :width="'430px'"
      @cancel="closeDemandDialog"
      :showCancel="false"
      :showConfirm="false"
      :closeOnClickModal="false"
    >
      <el-form ref="demandForm" :model="demandForm" :rules="demandRules">
        <el-input v-model="demandForm.genre" type="hidden"></el-input>
        <el-form-item label="选择项目:" prop="projectName">
          <select-tmpl v-model="demandForm.projectName" :dataOption="projectOptions" labels="name" values="id"
                       placeholder="请选择项目" @select="getSelect" size="small"></select-tmpl>
        </el-form-item>
        <el-form-item label="选择版本:" prop="projectVersion">
          <select-tmpl v-model="demandForm.projectVersion" :dataOption="versionOptions" labels="version" values="id"
                       placeholder="请选择版本" @select="selVersion" size="small"></select-tmpl>
        </el-form-item>
        <el-form-item>
          <el-input size="small" clearable v-if="treeData.length != 0" placeholder="输入关键字进行过滤"
                    v-model="filterText">
          </el-input>
          <el-tree ref="demandTree" :data="treeData" show-checkbox node-key="key" :default-checked-keys="checkedKeys"
                   :default-expanded-keys="treeExpandData" :props="defaultProps" @check="currentChecked"
                   :filter-node-method="filterNode"></el-tree>
        </el-form-item>
        <el-form-item label="类别:" prop="type">
          <select-tmpl v-model="demandForm.type" :dataOption="demandOptions.Demand_Role" labels="name" values="id"
                       placeholder="请选择" size="small"></select-tmpl>
        </el-form-item>
        <el-form-item label="耗时：">
          <!-- <el-input
            :autosize="{ minRows: 5, maxRows: 8}"
            placeholder="最小耗时为0.5小时"
            v-model="demandForm.costTime"
            size="small"
          ></el-input>-->
          <el-input-number size="small" v-model="demandForm.costTime" :precision="1" :step="0.5" :max="24"
                           :min="0.5"></el-input-number>&nbsp; 小时
          <br/>
          <span class="red">需求总耗时(最小单位为0.5小时)</span>
        </el-form-item>
      </el-form>
      <div class="dialogBottom">
        <el-button :loading="btnLoading" type="primary" size="small" @click="addDemandItem"
                   v-preventReClick>添加
        </el-button>
      </div>
    </dialog-panel>

    <!-- 批量设置 -->
    <dialog-panel title="批量设置" :dialogController="batchSetBord" :width="'430px'" @cancel="closebatchSetBord"
                  :showCancel="false" :showConfirm="false">
      <el-form ref="setForm" :model="setForm">
        <el-form-item label="类别:" prop="type">
          <select-tmpl v-model="setForm.type" :dataOption="demandOptions.Demand_Role" labels="name" values="id"
                       placeholder="请选择" size="small"></select-tmpl>
        </el-form-item>
        <el-form-item label="耗时：">
          <!-- <el-input
            :autosize="{ minRows: 5, maxRows: 8}"
            placeholder="最小耗时为0.5小时"
            v-model="demandForm.costTime"
            size="small"
          ></el-input>-->
          <el-input-number size="small" v-model="setForm.costTime" :precision="1" :step="0.5" :max="24"
                           :min="0.5"></el-input-number>&nbsp; 小时
          <br/>
          <span class="red">需求总耗时(最小单位为0.5小时)</span>
        </el-form-item>
      </el-form>
      <div class="dialogBottom">
        <el-button :loading="btnLoading" type="primary" size="small" @click="batchSetConfirm" v-preventReClick>
          提交
        </el-button>
      </div>
    </dialog-panel>
  </div>
</template>

<script>
import {Demand, Task, Meeting} from "./projectDTO";
import * as api from "./reportAPI";
import {dateFormat} from "utils/handle";

let demandFormList = [];
let dailyId = null;

export default {
  data() {
    return {
      currentUser: JSON.parse(localStorage.getItem("currentUser")),
      pickerDisabled: {
        disabledDate: (time) => {
          // return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          return time.getTime() > Date.now();
        },
      },
      dailyId: null,
      form: {
        reportTime: dateFormat(new Date()),
        feedback: "",
      },
      demandData: [],
      demand: Demand,
      rules: {},
      demandRules: {
        projectName: [
          {required: true, message: "请选择项目", trigger: "change"},
        ],
        projectVersion: [
          {required: true, message: "请选择版本", trigger: "change"},
        ],
        type: [{required: true, message: "请选择类别", trigger: "change"}],
      },
      taskRules: {
        type: [{required: true, message: "请选择类别", trigger: "change"}],
        projectId: [
          {required: true, message: "请选择项目", trigger: "change"},
        ],
        projectVersionId: [
          {required: true, message: "请选择版本", trigger: "change"},
        ],
      },
      taskData: [],
      overTimeVOList: [],
      overTime: '',
      task: Task,
      feedback: "",
      addTaskBord: false,
      isAdd: true,
      currentEditIdx: undefined,
      taskTitle: "新增任务",
      taskForm: {
        genre: "任务",
        type: "",
        projectId: "",//项目ID
        projectVersionId: "",//版本ID
        content: "",
        costTime: 0,
      },
      taskTextarea: "",
      costTime: "",
      taskOptions: {
        TASK_TYPE: [],
      },


      at: {},
      demandTableController: {
        isActive: true,
        selection: true,
        index: true,
        width: 180,
        rowKey: "",
      },
      tableController: {
        isActive: true,
        selection: false,
        index: true,
        width: 180,
        rowKey: "",
        key: 0
      },
      meetingController: {
        isActive: false,
        selection: false,
        index: true,
        width: 220,
        rowKey: "",
      },
      demandTitle: "新增需求",
      addDemandBord: false,
      demandForm: {
        genre: "需求",
        costTime: 0,
        projectName: "",
        projectVersion: "",
        type: "",
      },
      demandOptions: {
        Demand_Role: [],
      },
      otOptions: {
        Demand_Role: [],
      },
      dailyLeaveDTO: {
        leaveTotalTime: 0,
        leaveType: '',
      },
      projectOptions: [],
      versionOptions: [],
      checkedKeys: [],
      projectVersionId: "",
      defaultProps: {
        children: "children",
        label: "label",
      },
      treeData: [],
      btnLoading: false,
      disabledTime: false,
      value1: "",
      treeExpandData: [],
      meeting: Meeting,
      meetingData: [],
      filterText: "",
      batchSetBord: false,
      selectedItem: [],
      setForm: {
        type: "",
        costTime: 0,
      },

    };
  },
  watch: {
    filterText(val) {
      this.$refs.demandTree.filter(val);
    },
  },
  methods: {
    editTask(idx) {
      console.log(idx)
      new Promise((resolve) => {
        this.getSelect(this.taskData[idx].projectId, resolve)
      }).then(() => {
        this.isAdd = false;
        this.taskForm = JSON.parse(JSON.stringify(this.taskData[idx]))
        this.taskTitle = "修改任务";
        this.currentEditIdx = idx;
        this.addTaskBord = true;
        console.log("open")
      })
    },
    changeOption(list, index) {
      this.demandData.forEach((item, i) => {
        if (i == index) {
          return false
        }
        if (list.scope.row.demandId == item.demandId && list.scope.row.type == item.type) {
          this.$message.warning('存在同名需求，请修改类型或删除同名需求')
          list.scope.row.type = ''
        }
      })
      console.log('改变了', list, index);
    },
    closebatchSetBord() {
      this.batchSetBord = false;
    },
    batchSetConfirm() {
      this.btnLoading = true;
      if (!this.setForm.type) {
        this.$message.warning("请选择类型后提交");
        this.btnLoading = false;
        return;
      }
      let idList = []
      this.selectedItem.forEach((item) => {
        idList.push(item.demandId)
      });
      let tmpList = [...new Set(idList)]
      if (tmpList.length < this.selectedItem.length) {
        this.$message.warning('选项含有相同需求，无法进行批量设置，请重新选择')
        this.btnLoading = false;
        return
      } else {

        for (let item of this.selectedItem) {
          let l = this.demandData.filter(i => item.demandId == i.demandId)
          if (l.length > 1) {
            for (let subItem of this.demandData) {
              if (item == subItem) {
                continue
              }
              if (item.demandId == subItem.demandId && this.setForm.type == subItem.type) {
                this.$message.warning('存在同名且类型相同的需求，请重新选择类型')
                this.btnLoading = false;
                return
              }
            }
          }
        }
        this.selectedItem.forEach((item) => {
          item.type = this.setForm.type;
          item.costTime = (this.setForm.costTime / (this.selectedItem.length)).toFixed(2)
        });
        this.btnLoading = false;
        this.batchSetBord = false;
        this.$refs.demandTable.clearSelection();
      }
    },
    selectionChange(e) {
      this.selectedItem = e;
    },
    batchSet() {
      if (this.selectedItem.length == 0) {
        this.$message.warning("请选择要设置的项目");
        return;
      }
      this.batchSetBord = true;
    },
    pickerDate(e) {
      this.demandData = [];
      this.meetingData = [];
      this.taskData = [];
      // this.dailyLeaveDTO = {};

      this.form.reportTime = e;
      this.getCompleteDemand();
      // this.funGetMeeting();
    },
    add(type) {
      //  提交
      let f = {
        ...this.form,
      };
      // console.log('提交', f.reportTime)
      f.employeeId = this.currentUser.id;
      f.dailyDemandList = this.demandData;
      f.dailyTaskList = this.taskData;
      console.log(this.demandData)
      console.log(this.taskData)
      console.log(this.dailyLeaveDTO)
      f.dailyLeaveDTO = this.dailyLeaveDTO;//请假
      //不请假一天才进来
      if (this.dailyLeaveDTO.leaveTotalTime < 8) {
        if (
          this.demandData.length === 0 &&
          this.taskData.length === 0 &&
          !f.feedback
        ) {
          this.$message.warning(`不能提交空日报`);
          return;
        }
        let isEmpty = false;
        if (this.demandData) {
          this.demandData.forEach((item) => {
            if (!item.type) {
              isEmpty = true;
              return;
            }
          });
        }
        if (isEmpty) {
          this.$message.warning(`请填写需求类别`);
          return;
        }
        isEmpty = false;
        if (this.demandData) {
          this.demandData.forEach((item) => {
            if (!item.costTime) {
              isEmpty = true;
              return;
            }
          });
        }
        if (isEmpty) {
          this.$message.warning(`请填写需求类别`);
          return;
        }
      }
      if ((this.dailyLeaveDTO.leaveTotalTime && (!this.dailyLeaveDTO.leaveType)) || (!this.dailyLeaveDTO.leaveTotalTime) && (this.dailyLeaveDTO.leaveType)) {
        this.$message.warning(`请提交完整请假信息`);
        return;
      }

      this.btnLoading = true;
      if (type === -1) {
        api
          .addDaily(f)
          .then((res) => {
            if (res.code === 1000) {
              this.$message.success(`提交成功`);
              this.demandData = [];
              this.taskData = [];
              // this.dailyLeaveDTO = {};
              this.$router.go(-1);
            }
          })
          .finally(() => {
            this.btnLoading = false;
          });
      } else {
        // 更新日报
        if (this.$route.query.dailyId) {
          f.dailyId = this.$route.query.dailyId;
        } else {
          f.dailyId = this.dailyId;
        }
        api
          .resubmitDaily(f)
          .then((res) => {
            if (res.code === 1000) {
              this.$message.success(`提交成功`);
              this.demandData = [];
              this.taskData = [];
              // this.dailyLeaveDTO = {};
              this.$router.go(-1);
            }
          })
          .finally(() => {
            this.btnLoading = false;
          });
      }
    },
    getCompleteDemand() {
      console.log(515);
      api
        .getCompleteDemand({
          date: this.form.reportTime,
        })
        .then((res) => {
          console.log(111, res);
          res.data.forEach((item) => {
            let isExist = false;
            this.demandData.forEach((i) => {
              if (item.demandId == i.demandId) {
                isExist = true;
              }
            });
            if (isExist) {
              return;
            }
            this.demandData.unshift(item);
          });
        });
    },
    getChecked(e) {
      // console.log('勾选', e)
      //   this.checkedKeys = e.checkedKeys.checkedKeys
    },
    currentChecked(data, currentChecked) {
      // console.log('rrr勾选', data, 'dfd', currentChecked)
    },
    demandSummaryMethod(e) {
    },
    taskSummaryMethod(param) {
    },
    _getLabel(e, array, key) {
      return (
        (array.find((item) => {
          return item.id === e[key];
        })
          ? array.find((item) => {
            return item.id === e[key];
          }).name
          : e[key]) || ""
      );
    },
    getVersionName(e) {
      if (e.projectVersionVOList) {
        return e.type == 2
          ? e.projectVO.name +
          "(" +
          e.projectVersionVOList.map((item) => item.version).join("/") +
          ")"
          : "售前会议";
      } else {
        return "--";
      }
    },
    getTime(s, e) {
      let long = (new Date(e).getTime() - new Date(s).getTime()) / 1000;
      let day = Math.floor(long / (60 * 60 * 24));
      let hour = Math.floor((long - day * 60 * 60 * 24) / (60 * 60));
      let minues = Math.ceil((long - day * 60 * 60 * 24 - hour * 60 * 60) / 60);

      let h = Math.floor((long / (60 * 60)) * 100) / 100;
      return h + "h";
      // console.log('时间',long,day,hour,minues,h)
      // if (day) {
      //   return day + '天' + hour + '小时' + minues + '分钟'
      // } else if (hour) {
      //   return hour + '小时' + minues + '分钟'
      // } else {
      //   return minues + '分钟'
      // }
    },
    handleSelectionChange(e) {
      //   this.employList = e
    },
    funSlectOptions() {
      api.dictPage({dictGroupCode: "DAILY_WEEKLY_TASK_TYPE"}).then((res) => {
        console.log(res);
        this.taskOptions.TASK_TYPE = res.data.records;
      });
      api
        .dictPage({dictGroupCode: "DAILY_WEEKLY_DEMAND_TYPE"})
        .then((res) => {
          console.log(res);
          this.demandOptions.Demand_Role = res.data.records;
        });
      api
        .dictPage({dictGroupCode: "LEAVE_TYPE"})
        .then((res) => {
          console.log(res);
          this.otOptions.Demand_Role = res.data.records;
        });
    },
    addTask() {
      this.taskForm = {genre: "任务", costTime: '1'};
      this.addTaskBord = true;
      this.taskTitle = "新增任务";
      this.isAdd = true;
    },
    updateTaskItem() {
      this.$refs["taskForm"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;

          this.taskData[this.currentEditIdx] = this.taskForm
          this.tableController.key++;
          this.btnLoading = false;
          this.addTaskBord = false;
        }
      })
    },
    addTaskItem() {
      this.$refs["taskForm"].validate((valid) => {
        if (valid) {

          this.btnLoading = true;

          console.log('任务', this.taskForm)
          console.log('versionOptions', this.versionOptions)
          console.log('projectOptions', this.projectOptions)

          this.taskData.push(this.taskForm);
          this.btnLoading = false;
          this.addTaskBord = false;
          // 弹窗多个验证只有一个生效需求弹窗已做了处理 这里不需要做重置数据
          // this.$refs['taskForm'].resetFields();// 数据重置 验证
        }
      });
    },
    closeTaskDialog() {
      this.addTaskBord = false;
      // 弹窗多个验证只有一个生效需求弹窗已做了处理 这里不需要做重置数据
      // this.$refs['taskForm'].resetFields();// 数据重置 验证
    },
    addDemand() {
      this.demandForm = {genre: "需求", costTime: '1'};
      this.addDemandBord = true;
      this.treeData = [];
      this.filterText = "";
    },

    addDemandItem() {
      this.$refs["demandForm"].validate((valid) => {
        if (valid) {
          let checks = this.$refs.demandTree.getCheckedNodes();
          let checkDemand = [];
          checks.forEach((item) => {
            if (item && item.demandModuleId) {
              // 只勾选需求
              checkDemand.push(item);
            }
          });
          if (!checkDemand.length) {
            this.$message.warning("请选择需求");
            return;
          }
          console.log(checkDemand);
          this.btnLoading = true;

          let ave =
            Math.floor((this.demandForm.costTime / checkDemand.length) * 100) /
            100;
          let aveNum = ave * 100 * 100;
          let collCost =
            Math.floor(ave * 10000 * (checkDemand.length - 1)) / 10000;
          // console.log('dddd', ave, collCost, this.demandForm.costTime, (ave * 100), aveNum, (checkDemand.length - 1))
          let existList = [];
          let newList = [];
          for (let i = 0; i < checkDemand.length; i++) {
            let isExist = false;
            this.demandData.forEach((j) => {
              if (j.demandId == checkDemand[i].key) {
                if (this.demandForm.type == j.type) {
                  isExist = true
                }
              }
            });
            if (isExist) {
              existList.push(checkDemand[i].name);
            } else {
              if (checkDemand[i] && checkDemand[i].demandModuleId) {
                // 只勾选需求
                newList.push({
                  projectName: this.projectOptions.find((item) => {
                    return item.id === this.demandForm.projectName;
                  }).name,
                  projectVersion: this.versionOptions.find((item) => {
                    return item.id === this.demandForm.projectVersion;
                  }).version,
                  demandId: checkDemand[i].key,
                  demandName: checkDemand[i].label,
                  genre: "需求",
                  costTime:
                    i + 1 === checkDemand.length
                      ? Math.floor(
                      this.demandForm.costTime * 100 - collCost * 100
                    ) / 100
                      : ave,
                  type: this.demandForm.type,
                });
              }
            }

          }
          if (existList.length > 0) {
            let str = existList[0]
            for (let i = 1; i < existList.length; i++) {
              str += '，' + existList[i]
            }
            this.$message.warning('需求“' + str + '”已存在，请重新选择！')
          } else {
            this.demandData.push(...newList)
            this.addDemandBord = false;
            this.$refs["demandForm"].resetFields(); // 数据重置 验证
          }
          this.btnLoading = false;
        }
      });
    },
    closeDemandDialog() {
      this.addDemandBord = false;
      this.$refs["demandForm"].resetFields(); // 数据重置 验证
    },
    delDemand(i) {
      this.demandData.splice(i, 1);
    },
    delTask(i) {
      this.taskData.splice(i, 1);
    },
    getSelect(e, resolve) {
      this.treeData = [];
      this.versionOptions = [];
      if(this.addTaskBord){//判断是否任务表单
        if(this.taskForm.projectVersionId != undefined && this.taskForm.projectVersionId !== ""){
          this.taskForm.projectVersionId = "";
        }
      }
      if (e) {
        api.getVersionPage({projectId: e, size: -1}).then((res) => {
          this.versionOptions = res.data.records;
          console.log(res.data.records)
          if (resolve) {
            resolve();
          }
        });
      }
    },
    selVersion(e) {
      this.treeData = [];
      if (e) {
        api.getDemandList(e).then((res) => {
          this.treeData = res;
          this.treeExpandData.push(this.treeData[0].key);
        });
      }
    },
    funGetAllProject() {
      // api.listProject().then(res => {
      //   this.projectOptions = res.data
      // })
      api.getProject({employeeId: this.currentUser.id, size: -1}).then((res) => {
        console.log(res);
        this.projectOptions = res.data.records;
      });
    },
    funGetMeeting() {
      let param = {
        current: 1,
        employeeId: this.currentUser.id,
        meetingTime: this.form.reportTime,
        size: -1,
      };
      api.getPageMeeting(param).then((res) => {
        this.meetingData = res.data.records;
      });
    },
    funGetDaily() {
      // 详情
      if (this.$route.query.dailyId !== -1) {
        api.getDaily(this.$route.query.dailyId).then((res) => {
          console.log("111", res);
          if (res.code === 1000) {
            this.form = res.data;
            this.form.reportTime = res.data.reportTime;
            // console.log('uuuu', this.form.reportTime, res.data)
            if (res.data.dailyDemandVOList) {
              this.demandData.push(...res.data.dailyDemandVOList);
            }
            this.taskData = res.data.dailyTaskVOList
              ? res.data.dailyTaskVOList
              : [];
            this.disabledTime = true;
            this.funGetMeeting();
            this.getCompleteDemand();

            this.overTimeVOList = res.data.overTimeVOList
            this.dailyLeaveDTO.leaveType = res.data.dailyLeave ? res.data.dailyLeave.leaveType : '';
            this.dailyLeaveDTO.leaveTotalTime = res.data.dailyLeave ? res.data.dailyLeave.leaveTotalTime : '';
          }
        });
      }
    },
    funGetDailyByDate() {
      //新增
      console.log(1111122223333);
      api.getDailyByDate({date: this.form.reportTime}).then((res) => {
        if (res.code === 1000) {
          // debugger
          if (res.data) {
            this.form = res.data;
            this.form.reportTime = res.data.reportTime;
            if (res.data.dailyDemandVOList) {
              this.demandData.push(...res.data.dailyDemandVOList);
            }
            this.taskData = res.data.dailyTaskVOList
              ? res.data.dailyTaskVOList
              : [];
            this.dailyId = res.data.id;
            this.disabledTime = true;
            console.log(this.demandData);
          }
          this.getCompleteDemand();
        }
      });
    },
    funReportTime() {
      this.form.reportTime = this.$route.query.reportTime;
      this.disabledTime = true;
    },
    filterNode(value, data) {
      console.log("333", value, data);
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
  },
  created() {
    // debugger
    this.funSlectOptions();
    this.funGetAllProject();
    this.$route.query.dailyId && this.funGetDaily();
    this.$route.query.reportTime && this.funReportTime();
    !this.$route.query.dailyId && this.funGetDailyByDate();
    // this.funGetMeeting();
  },
};
</script>
<style scoped>
.dialogBottom {
  margin-top: 20px;
  text-align: right;
}

.txtContent {
  margin-top: 20px;
  text-align: center;
}

.w300 {
  width: 220px;
}

.txtOverflow {
  overflow: auto;
}

.elInput >>> textarea {
  margin-top: 20px;
  outline: none;
  overflow: auto;
  /* height: auto; */
  /* border: none; */
  /* border: 0 none; */
  border: 1px solid #fff !important;
  padding: 0;
  resize: none;
}

.table-content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.marginLeft {
  margin-left: 1px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.box-card {
  width: 80%;
  margin: 20px auto;
}

.partmentItem {
  display: inline-block;
  padding: 0px 10px;
  background: #eee;
  height: 25px;
  line-height: 25px;
  margin-right: 15px;
  font-size: 14px;
}

.el-divider--horizontal {
  margin: 20px 0;
  background: 0 0;
  border-top: 2px dashed #e8eaec;
}

.ot-mian {
  overflow: hidden;
}

.ot {
  float: left;
  margin-bottom: 10px;
}

.ot2 {
  float: right;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/report-manage/daily.vue